import gql from 'graphql-tag';

export default gql`
mutation deleteFA_Assortment($id: Int!){
    fakturaAssist{
		deleteFA_Assortment(id: $id){
		    id
    }
  }
}`;